import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<any>> {
    const params = new URLSearchParams(window.location.search);
    const token = window.sessionStorage.getItem('token') || params.get('token');

    let url = request.url;

    console.log(url);

    if (!url.startsWith('http')) {
      const baseUrl = environment.apiUrl.replace(/\/$/, '');
      const endpoint = url.replace(/^\//, '');
      url = `${baseUrl}/${endpoint}`;
    }

    if (token && !url.includes('token=')) {
      url += (url.includes('?') ? '&' : '?') + `token=${token}`;
    }

    const cloned = request.clone({ url });
    return next.handle(cloned);
  }
}
